import { create } from "zustand";

type NewsNoticeModalState = {
  isOpen: boolean;
  newsNoticeId: string | null;
  defaultValues: Partial<{
    noticeType: "news" | "notice";
    title: string;
    description: string;
    author: string;
    category: string;
    tags: string[];
    priority: "low" | "normal" | "high" | "urgent";
    status: "draft" | "published" | "archived";
    date: Date;
    expirationDate: Date;
    featuredImageId: string;
    attachmentId: string;
  }>;
  setIsModalOpen: (isOpen: boolean) => void;
  setNewsNoticeId: (id: string | null) => void;
  setDefaultValues: (
    values: Partial<{
      noticeType: "news" | "notice";
      title: string;
      description: string;
      author: string;
      category: string;
      tags: string[];
      priority: "low" | "normal" | "high" | "urgent";
      status: "draft" | "published" | "archived";
      date: Date;
      expirationDate: Date;
      featuredImageId: string;
      attachmentId: string;
    }>,
  ) => void;
};

export const useNewsNoticesModal = create<NewsNoticeModalState>((set) => ({
  isOpen: false,
  newsNoticeId: null,
  defaultValues: {},
  setIsModalOpen: (isOpen) => set({ isOpen }),
  setNewsNoticeId: (id) => set({ newsNoticeId: id }),
  setDefaultValues: (values) => set({ defaultValues: values }),
}));
